import { createFileRoute } from "@tanstack/react-router";
import { seoFor } from "@/lib/i18n/keywordPools";
import Terms from "@/pages/Terms";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["terms"] }).meta },
      { name: "description", content: "The terms governing your use of Statlign — service description, eligibility, credits and purchases, acceptable use, disclaimers, and limitation of liability." },
      { property: "og:title", content: "Terms of Service | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "The terms governing your use of Statlign — service description, eligibility, credits and purchases, acceptable use, disclaimers, and limitation of liability." },
      { name: "twitter:title", content: "Terms of Service | Statlign" },
      { name: "twitter:description", content: "The terms governing your use of Statlign — service description, eligibility, credits and purchases, acceptable use, disclaimers, and limitation of liability." },
    ],
  }),
  component: () => (
    <MainLayout>
      <Terms />
    </MainLayout>
  ),
});
